import { PlateId, useEditorRef, useEditorState } from '@udecode/plate-common';

import { MyEditor, MyValue } from './plateTypes';

/**
 * Typed {@link useSlateStatic} & PlateEditor. Needs to be called in a child
 * component inside the `Plate` provider. Else, use `useMyPlateEditorRef`.
 */
export const useMyEditorRef = (): MyEditor => useEditorRef<MyValue, MyEditor>();

export const useMyEditorState = (id?: PlateId): MyEditor =>
  useEditorState<MyValue, MyEditor>(id);

/**
 * Used to fetch the typed plate editor, can be used outside of the Plate
 * provider
 *
 * @param id Plate editor id
 * @returns
 */
export const useMyPlateEditorRef = (id?: PlateId): MyEditor =>
  useEditorRef<MyValue, MyEditor>(id);
